export const ENTITY_TYPE = {
  RESELLER: 'reseller',
  ORGANIZATION: 'organization',
  DEVICE: 'device'
}

export const FEATURES = {
  DYNAMIC_ADJUST: 'dynamicAdjust'
}
